export enum DataSchemaTypes {
  Model = 'model', /* shared model across the application, defined by end user */
  UIDataEventPayload = 'ui-data-event-payload',
  UIDataStoreState = 'ui-data-store-state',
  Enum = 'enum'
}
